/*
sai krishna 01/19/2023 2698197526 added profile of batch table for closed
Ashraf 01/25/2023 2698197526 fixed tab routing issue
Ashraf 01/30/2023 2698197526 fixed column data issue
sai krishna 01/31/2023 2698197526 added deleted count in table
Ashraf 01/31/2023 2698197526 added failed count column
Dilip 03/o8/2023 2698197526 added undo batch functionality
Sohel 03/08/2023 2698197526 hide undo batch functionality
Sohel 04/26/2023 2698197526 Added Date and Time Column
Prakash 16/05/2023 2698197526 fixed icon issues
Akhila 06/08/2023 2699762545 created date change to date created field and column
*/
import React, {useEffect, useState, useContext, createRef} from 'react';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {
  resetStatusWorkQueueList,
} from '../../../../redux/reducers/WorkQueue';
import {useSelector, useDispatch} from 'react-redux';
import SelectTabContextProvider from '../../../../components/SelectTabContext/SelectTabContext';
import PageLoader from '../../../../components/PageLoader';
import {TablePagination} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {tablePageRows, defaultRows} from '../../../../constants/ReusableTablePagination';
import {useHistory} from 'react-router';
import moment from 'moment';
import {httpPaginationPost} from '.././../../../util/Rest';
import {setShowDashboardWorkQueue} from '../../../../redux/reducers/role';
import SettingsBackupRestoreOutlinedIcon from '@material-ui/icons/SettingsBackupRestoreOutlined';
import {
  postUndoBatch,
  resetMessage,
  ResetDownloadMsg as resetDownloadMsg,
  postApprovedUrl,
} from '../../../../redux/reducers/accountBatch';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    // backgroundColor: "#fff",
    'borderRadius': '4px',
    'border': '1px solid #f3f3f3',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
      backgroundColor: '#fff',
    },
    '& .MuiAccordionSummary-root': {
      backgroundColor: '#f3f3f3',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    'backgroundColor': '#38FA8A',
    'padding': '3px 10px',
    'borderRadius': 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
      color: '#FFF',
    },
  },
  detailsCard: {
    padding: 10,
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },

  cardStyles: {
    whiteSpace: 'nowrap',
    padding: '0 15px',
  },
  labelName: {
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
  },
  inputLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '600',
    },
  },
  selectGender: {
    fontSize: '13px',
  },
  selectLabel: {
    fontWeight: '600 !important',
  },
  datePicker: {
    '& .MuiIconButton-root': {
      'padding': '0px !important',
      ' & .MuiSvgIcon-root': {
        fontSize: '1.3rem',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '6px',
    },
  },
  textField: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '40px !important',
    },
  },
  popper: {
    zIndex: '9 !important',
  },
  link: {
    color: '#320469',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'articulat-cf sans-serif ',
  },
}));

const Owned = ({value, setValue, hideActions = false}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const {setPosition} = useContext(SelectTabContextProvider);
  const [title, setTitle] = useState('');
  const [Description, setDescription] = useState('');
  const [isAction, setIsAction] = useState('');
  const [actionData, setActionData] = useState({});
  const tableRef = createRef();
  useEffect(() => {
    setPosition(0);
  }, []);

  const {
    isLoading,
    workQueueList,
    workQueueListStatus,
  } = useSelector(({workQueue}) => workQueue);

  const {roleData} = useSelector(({role}) => role);
  const {
    successMsg,
    errorMsg,
    actionStatus,
    isLoading: loads,
    downloadSuccessMsg,
  } = useSelector(({accountBatch}) => accountBatch);

  useEffect(() => {
    if (downloadSuccessMsg) {
      setTimeout(() => {
        dispatch(resetDownloadMsg());
      }, 2500);
    }
  }, [downloadSuccessMsg]);

  useEffect(() => {
    if (errorMsg || successMsg) {
      tableRef?.current?.onQueryChange();
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2500);
    }
  }, [errorMsg, successMsg]);

  useEffect(() => {
    dispatch(setShowDashboardWorkQueue(''));
  }, []);

  useEffect(() => {
    if (workQueueListStatus === 200) {
      setTimeout(() => {
        resetStatusWorkQueueList();
      }, 2500);
    }
  }, [dispatch, workQueueListStatus, workQueueList, roleData]);

  const columns = [
    {
      title: 'Batch Name',
      field: 'batchName',
      render: (rowData) =>
        rowData?.insertCount > 0 ? (
          <div
            className={classes.link}
            onClick={() => {
              history.push({
                pathname: `/batch-account-list`,
                state: {
                  BatchName: rowData.batchName,
                  closedBatch: 'Yes',
                  tabValue: value === 2 ? 2 : 1,
                  BatchId:rowData.dmbatchId
                },
              });
            }}
          >
            {rowData.batchName}
          </div>
        ) : (
          <div>{rowData?.batchName}</div>
        ),
    },
    {
      title: 'Batch Status',
      field: 'batchStatus',
    },
    {
      title: 'Code',
      field: 'dmCode',
    },
    {
      title: 'Type',
      field: 'dmType',
    },
    {
      title: 'Status',
      field: 'dmStatus',
      render: (rowData) =>
        rowData?.dmStatus?.toLowerCase() === 'rejected' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>Rejected</span>
          </div>
        ) : (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Approved</span>
          </div>
        ),
    },
    {
      title: 'Total',
      field: 'fileCount',
    },
    {
      title: 'Successful ',
      field: 'insertCount',
    },
    {
      title: 'Failed',
      field: 'failedCount',
      render: (rowData) =>
        rowData?.batchStatus === 'IN_PROGRESS' || rowData?.failedCount === 0 ? (
          <div>{rowData?.failedCount}</div>
        ) : (
          <div
            className={classes.link}
            onClick={() => {
              history.push({
                pathname: `/batch-account-list`,
                state: {
                  BatchName: rowData.batchName,
                  failedCount: true,
                  BatchId:rowData.dmbatchId
                },
              });
            }}
          >
            {rowData.failedCount}
          </div>
        ),
    },
    {
      title: 'Deleted ',
      field: 'deleteCount',
    },

    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) =>
        rowData.createdDate ? moment(rowData.createdDate).format('MM/DD/YYYY') : '',
    },
    {
      title: value === 2 ? 'Rejected Date and Time' : 'Approved Date and Time',
      field: 'approveDate',
      render: (rowData) => {
        return rowData.approveDate ?
          moment(rowData.approveDate).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A') :
          '';
      },
    },
  ];
  const handleClose = () => {
    setIsAction(false);
    setActionData({});
  };

  useEffect(() => {
    if (actionStatus === 200) {
      handleClose();
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2500);
    }
  }, [actionStatus]);
  
  useEffect(() => {
    if (workQueueListStatus === 200) {
      setTimeout(() => {
        resetStatusWorkQueueList();
      }, 2500);
    }
  }, [dispatch, workQueueListStatus, workQueueList, roleData]);

  const handleSubmit = () => {
    dispatch(postUndoBatch(actionData?.dmbatchId));
  };

  return (
    <div>
      <DeleteTableRecordPopup
        open={isAction}
        dialogClose={handleClose}
        title={title}
        value={Description}
        handleSubmit={handleSubmit}
      />
      <div className="global-field-table new-standard-textfields">
        <GuiTable
          title=""
          columns={columns}
          tableRef={tableRef}
          // data={generatedByData}
          data={(query) =>
            new Promise((resolve) => {
              const url = `dmbatch/search/all`;

              const passValues = {
                // accessRole: roleData?.userDetails?.role,
                // orderBy: query.orderBy && query.orderBy.field  ? query.orderBy.field : "",
                // orderDirection:query?.orderDirection ? query?.orderDirection : "",
                // search: "",
                batchName: '',
                batchStatus: '',
                createdDate: '',
                // dmStatus: "approved",
                dmStatusList: value === 2 ? ['Rejected'] : ['Approved'],
                dmType: '',
                orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                orderDirection: query?.orderDirection ? query?.orderDirection : '',
                limit: query.pageSize ? query.pageSize : null,
                page:
                  arrayLast && query?.page >= 1 ?
                    query.page :
                    arrayLast ?
                      (query.page <= 1 && query.page + 1) || query.page - 1 :
                      query.page + 1,
              };
              httpPaginationPost(url, passValues)
                .then((response) => {
                  if (response?.status === 200) {
                    const data = response.data.response.resultObjects;
                    console.log('data', data);
                    setArrayLast(data.length === 1);
                    resolve({
                      data: data.length > 0 ? data : [],
                      page: response.data.response.page - 1,
                      totalCount: response.data.response.count,
                    });
                    // setArrayLast(response.data.response.resultObjects.length === 1);
                  } else {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  }
                })
                .catch((response) => {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                  dispatch({
                    type: 'FETCH_ERROR',
                    payload: response && response.message ? response.message : null,
                  });
                });
            })
          }
          localization={{
            body: {editRow: {deleteText: 'Are you sure you want to delete this record?'}},
          }}
          options={{
            search: false,
            toolbar: false,
            pageSizeOptions: tablePageRows,
            pageSize: rows,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          actions={
            hideActions ?
              [
                (rowData) => {
                  return {
                    icon: () => <GetAppOutlinedIcon />,
                    tooltip: !rowData?.acknowledgementDocKey ? '' : 'Download',
                    disabled: !rowData?.acknowledgementDocKey,
                    onClick: (event, rowData) => {
                      dispatch(
                        postApprovedUrl({
                          dockey: rowData?.acknowledgementDocKey,
                        }),
                      );
                    },
                  };
                },
              ] :
              [
                {
                  icon: () => (
                    <>
                      <SettingsBackupRestoreOutlinedIcon />
                    </>
                  ),
                  tooltip: 'Undo',
                  onClick: (event, rowData) => {
                    setActionData(rowData);
                    setTitle('Undo Batch');
                    setDescription(
                        `Are you sure you want to undo this ${rowData?.batchName} batch ?`,
                    );
                    setIsAction(true);
                  },
                },
              ]
          }
          components={{
            Pagination: (props) => (
              <TablePagination
                {...props}
                SelectProps={{
                  inputProps: {'aria-label': 'Rows per screen'},
                }}
                labelRowsPerPage={'Rows per screen:'}
                onChangeRowsPerPage={(event) => {
                  props.onChangeRowsPerPage(event);
                  setRows(event.target.value);
                }}
              />
            ),
          }}
        />
      </div>
      {(isLoading || loads) && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {(successMsg || downloadSuccessMsg) && (
        <SuccessSnackbar successMsg={successMsg || downloadSuccessMsg} />
      )}
    </div>
  );
};

export default Owned;
